<template>
  <div class="news_wrap"
       @mouseenter="showBtn=true"
       @mouseleave="showBtn=false">
    <div class="news_tit" v-if="newsList.length > 0">News & Blogs</div>

    <div class="slider-hover-wrapper">
      <button class="arrow-btn left" v-show="showBtn" @click="prev">&lt;</button>

      <div class="slider-section">
        <!-- 🔥 新增：移动端滑动触摸事件 -->
        <div class="slider-container"
             @touchstart="touchStart"
             @touchmove="touchMove"
             @touchend="touchEnd">
          <div class="slider-track" :style="{ transform: `translateX(-${currentIndex * cardWidth}px)`, transition: 'transform 0.5s ease' }">
            <div class="news-card" v-for="item in newsList" :key="item.id" @click="handleToNewsDetails(item.id)">
              <div class="card-img">
                <img :src="item.image" alt="" />
              </div>
              <div class="card-date">
                <img src="@/assets/calendar.png" class="date-icon" alt="">
                {{ formatDate(item.createTime) }}
              </div>
              <div class="card-title">{{ item.title }}</div>
              <div class="card-bottom">
                <button class="read-btn">Read More</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button class="arrow-btn right" v-show="showBtn" @click="next">&gt;</button>
    </div>
  </div>
</template>

<script>
import { getNewsHomeRecommend } from '../../api/news'
import ScrollReveal from 'scrollreveal'

export default {
  data() {
    return {
      newsList: [],
      currentIndex: 0,
      showBtn: false,
      autoPlay: null,
      cardWidth: 0,
      maxIndex: 0,
      isMobile: false,
      // 🔥 新增：滑动需要的变量
      touchStartX: 0,
      touchDeltaX: 0
    }
  },
  methods: {
    handleToNewsDetails(id) {
      this.$router.push('/news_detail/' + id)
    },
    updateLayout() {
      const box = document.querySelector('.news-card')
      if (!box) return
      this.isMobile = window.innerWidth < 769
      this.cardWidth = this.isMobile
          ? box.offsetWidth
          : box.offsetWidth + 20
      this.maxIndex = this.isMobile
          ? this.newsList.length - 1
          : this.newsList.length - 3
    },
    async getNewsHomeRecommendFunc() {
      const res = await getNewsHomeRecommend()
      if (res.data) {
        this.newsList = res.data.data || []
      }
      this.$nextTick(() => {
        this.updateLayout()
        window.addEventListener('resize', this.updateLayout)
        ScrollReveal().reveal(['.news_tit', '.news-card'], {
          distance: 10,
          duration: 800,
          interval: 100,
          origin: 'bottom'
        })
      })
    },
    formatDate(t) {
      if (!t) return ''
      return new Date(t).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
    },
    next() {
      if (this.currentIndex < this.maxIndex) {
        this.currentIndex++
      }
    },
    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--
      }
    },
    startAuto() {
      this.autoPlay = setInterval(() => {
        if (this.currentIndex >= this.maxIndex) {
          this.currentIndex = 0
        } else {
          this.currentIndex++
        }
      }, 4000)
    },

    // 🔥 新增：移动端滑动逻辑
    touchStart(e) {
      if (!this.isMobile) return
      this.touchStartX = e.touches[0].clientX
    },
    touchMove(e) {
      if (!this.isMobile) return
      this.touchDeltaX = e.touches[0].clientX - this.touchStartX
    },
    touchEnd() {
      if (!this.isMobile) return
      const threshold = 50 // 滑动超过50px触发切换
      if (this.touchDeltaX > threshold) {
        this.prev() // 右滑 → 上一张
      } else if (this.touchDeltaX < -threshold) {
        this.next() // 左滑 → 下一张
      }
      this.touchDeltaX = 0
    }
  },
  mounted() {
    this.getNewsHomeRecommendFunc()
    this.startAuto()
  },
  beforeDestroy() {
    clearInterval(this.autoPlay)
    window.removeEventListener('resize', this.updateLayout)
  }
}
</script>

<style lang="scss" scoped>
.news_wrap {
  width: 100%;
  margin: 50px 0;
  text-align: center;

  .news_tit {
    font-size: 40px;
    font-weight: bold;
    color: #203040;
    font-family: 'Roboto_Bold', sans-serif;
  }
}

.slider-hover-wrapper {
  position: relative;
  width: 90%;
  margin: 0 auto;
  padding: 0;
  box-sizing: border-box;
}

.slider-section {
  position: relative;
  width: 100%;
  margin: 70px 0;
}

.slider-container {
  width: 100%;
  overflow: hidden; /* 🔥 固定：必须hidden，由JS控制位移 */
}

.slider-track {
  display: flex;
  gap: 20px;
  padding-left: 5px;
}

.news-card {
  width: calc((100% - 40px) / 3);
  flex-shrink: 0;
  background: #fff;
  border: 1px solid #eee;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.35s ease;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
  }

  .card-img {
    width: 100%;
    height: 340px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.4s ease;
    }
  }

  &:hover .card-img img {
    transform: scale(1.1);
  }

  .card-date {
    padding: 16px 20px 0;
    text-align: left;
    color: #203040;
    font-size: 20px;
    display: flex;
    align-items: center;
    font-family: 'Roboto', sans-serif;
    gap:8px;

    .date-icon{
      width:20px;
      height:auto;
    }

    @media (max-width:768px){
      .date-icon{
        width:16px;
      }
    }
  }

  .card-title {
    padding: 10px 20px;
    min-height: 90px;
    max-height: 120px;
    text-align: left;
    font-size: 22px;
    font-weight: bold;
    color: #203040;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    font-family: 'Roboto', sans-serif;
  }

  .card-bottom {
    margin-top: auto;
    padding: 0 20px 25px;
    text-align: left;
  }

  .read-btn {
    padding: 12px 30px;
    border: 1px solid #880f53;
    background: #fff;
    color: #880f53;
    font-weight: bold;
    cursor: pointer;
    transition: 0.3s;

    &:hover {
      background: #880f53;
      color: #fff;
    }
  }
}

.arrow-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 70px;
  background: #880f53;
  color: #fff;
  border: none;
  font-size: 22px;
  cursor: pointer;
  z-index: 9999;
}

.arrow-btn.left {
  left: -55px;
}
.arrow-btn.right {
  right: -55px;
}

.arrow-btn:hover {
  background: #6f063f;
}

/* 移动端专属适配 768px及以下 */
@media (max-width: 768px) {
  .slider-section {
    margin: 30px 0;
  }

  .slider-hover-wrapper {
    width: 85%; /* 宽度85% */
  }
  .slider-track {
    gap: 0;
    padding-left: 0;
  }
  .news-card {
    width: 100% !important;
    flex-shrink: 0;
  }
  .news-card .card-img {
    height: 220px;
  }
  .news_wrap .news_tit {
    font-size: 28px;
  }
  .news-card .card-date {
    font-size: 15px;
    padding: 12px 15px 0;
  }
  .news-card .card-title {
    font-size: 18px;
    padding: 8px 15px;
    min-height: auto;
    max-height: 80px;
  }
  .news-card .card-bottom {
    padding: 0 15px 20px;
  }
  .news-card .read-btn {
    padding: 10px 24px;
    font-size: 15px;
  }
  /* 隐藏切换按钮 */
  .arrow-btn {
    display: none !important;
  }
}
</style>